import axios from '../../bootstrap';

/**
 * Theme
 */
/**
 * @param {string} themecolor
 */
export function axiosGetTheme(themecolor) {
    return axios.get(
        `/api/admin/sitetheme/getthemestyle?theme_color=${themecolor}`
    );
}

/**
 * @param {{ fullwidth: string; theme_color: string; theme_css: string; }} objSetting
 */
export function axiosSetTheme(objSetting) {
    return axios.post('/api/admin/sitetheme/setthemestyle', objSetting);
}

/**
 * MENU
 * */

/**
 * @param {{ location: string; title: string; }} objData
 */
export function axiosAddMenu(objData) {
    return axios.post('/api/admin/menu/new', objData);
}

/**
 * @param {{ type: any; menu_id?: any; title?: string | number | string[]; icon?: any; badge_title?: string | number | string[]; badge_style?: any; target?: string; menu_type?: string | number | string[]; target_id?: string; slug?: string; url?: string | number | string[]; }} objData
 */
export function axiosUpdateMenu(objData) {
    var axiosRAction,
        type = objData.type;
    switch (type) {
        case 'rename':
            axiosRAction = axios.post('/api/admin/menu/rename', objData);
            break;
        case 'icon':
            axiosRAction = axios.post('/api/admin/menu/icon', objData);
            break;
        case 'badge':
            axiosRAction = axios.post('/api/admin/menu/icon', objData);
            break;
        case 'target':
            axiosRAction = axios.post('/api/admin/menu/target', objData);
            break;
        case 'url':
            axiosRAction = axios.post('/api/admin/menu/url', objData);
            break;
        default:
            break;
    }

    return axiosRAction;
}

/**
 * @param {{ menu_json: any; }} objData
 */
export function axiosSaveMenu(objData) {
    return axios.post('/api/admin/menu/savemenu', objData);
}

/**
 * @param {{ type: string; menu_id: any; }} objData
 */
export function axiosDeleteMenu(objData) {
    return axios.post('/api/admin/menu/delete', objData);
}

/**
 * PAGE OPTION
 * @param {{ slug_id: number; }} objData
 */
export function axiosSetHideorUnhide(objData) {
    return axios.post('/api/admin/pageoption/setHide', objData);
}

/**
 * @param {{ slug_id: number; }} objData
 */
export function axiosDeletePageOrPost(objData) {
    return axios.post('/api/admin/pageoption/delete', objData);
}

/**
 * @param {{ slug_id: number; }} objData
 */
export function axiosSetToHome(objData) {
    return axios.post('/api/admin/pageoption/setHomepage', objData);
}

/**
 * @param {{ slug_id: number; }} objData
 */
export function axiosSetDuplicate(objData) {
    return axios.post('/api/admin/pageoption/duplicate', objData);
}

/**
 * @param {{ page_name: string; slug_id: number; }} objData
 */
export function axiosRenamePageAndPost(objData) {
    return axios.post('/api/admin/pageoption/rename', objData);
}

/**
 * HEADER
 * @param {{ page_id: any; header_style: any; menu_style: any; topmenu_style: any; content_edit: any; content_view: any; cdn: any[]; }} objData
 */
export function axiosSaveHeaderStyle(objData) {
    return axios.post('/api/admin/header/saveHeaderStyle', objData);
}

/**
 * @param {{ page_id: any; topmenu_style: any; }} objData
 */
export function axiosSaveTopMenuStyle(objData) {
    return axios.post('/api/admin/header/saveTopMenuStyle', objData);
}

/**
 * @param {{ page_id: any; menu_style: any; }} objData
 */
export function axiosSaveMenuStyle(objData) {
    return axios.post('/api/admin/header/saveMenuStyle', objData);
}

/**
 * SAVE
 * @param {{ savetype: string; isMasterFooter?: string | number | string[]; isCustomFooter?: any; footerStyle?: any; slug_id: any; footer_content_edit?: any; footer_content_view?: any; header_content_view?: any; header_content_edit?: any; cdn?: any[]; isMasterHeader?: string | number | string[]; isHomepage?: string | number | string[]; isBanner?: any; global_post?: any; page_content_edit?: any; page_content_view?: any; meta_title_auto?: any; meta_des_auto?: any; use_sidebar?: any; isCustom_sidebar?: any; left_content_edit?: any; left_content_view?: any; right_content_edit?: any; right_content_view?: any; widget_global_settings?: {}; }} objData
 */
export function axiosSaveSite(objData) {
    return axios.post('/api/admin/savesite', objData);
}

/**
 * @param {{ logo: any; logo_mobile: any; tel: any; linktohomepage: string; sitebrand: any; email: any; titlecontact: any; address: any; }} objData
 */
export function axiosSaveSettingBrand(objData) {
    return axios.post('/api/admin/saveBrand', objData);
}

/**
 * @param {{ backtotop: any; }} objData
 */
export function axiosSaveSettingBacktotop(objData) {
    return axios.post('/api/admin/saveBacktotop', objData);
}

/**
 * @param {{ page_name: any; showMenu: number; }} objData
 */
export function axiosAddPage(objData) {
    return axios.post('/api/admin/addPage', objData);
}

/**
 * @param {{ slug_id: any; }} objData
 */
export function axiosResetSidebar(objData) {
    return axios.post('/api/admin/resetSidebar', objData);
}
